import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Integration, IntegrationType } from '@pdqdev/pdq-shared/dist/entities';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '@core/services/api/api.service';
import { IntegrationsService } from '@services/integrations/integrations.service';
import { ToastService } from '@storybook/services/toast/toast.service';

enum WidgetContext {
  TICKET = 'ticket',
  CUSTOMER = 'customer',
}

@Component({
  selector: 'richpanel-settings',
  templateUrl: './richpanel-settings.component.html',
  styleUrls: ['./richpanel-settings.component.scss'],
  standalone: false,
})
export class RichpanelSettingsComponent implements OnInit, OnDestroy {
  @Input() integrationType: IntegrationType;
  @Input() integration: Integration | any;

  apiKey: string = '';
  bearerToken: string = '';

  destroy$ = new Subject();
  constructor(
    private apiService: ApiService,
    private integrationService: IntegrationsService,
    private toastService: ToastService,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.integrationService.integrations$.pipe(takeUntil(this.destroy$)).subscribe((integrations) => {
      this.integration = integrations[this.integrationType.name].instance;
      this.bearerToken = this.integration?.metadata?.secret;
    });

    this.initCredentials();
  }

  initCredentials() {
    if (this.integration?.metadata?.apikey) {
      this.apiKey = this.integration?.metadata?.apikey;
    }

    if (this.integration?.metadata?.secret) {
      this.bearerToken = this.integration?.metadata?.secret;
    }
  }

  save() {
    this.apiService
      .post(`integrations/richpanel/secret/`, {
        secret: this.apiKey,
      })
      .subscribe(
        (updatedIntegration) => {
          this.integrationService.updateIntegrationState(updatedIntegration);
          this.toastService.showToast({
            mode: 'success',
            message: `API key saved`,
          });
        },
        (err) => {
          console.log(err);
          this.toastService.showToast({
            mode: 'danger',
            message: `Failed to save API key`,
          });
        },
      );
  }
}
